import { IllustrationProps } from 'fe-design-base/assets/types';
import Box from 'fe-design-base/atoms/Box';

import hey_envelope from './imageFiles/hey_envelope.png';

const HeyEnvelope = (props: IllustrationProps) => (
  <Box
    w={72}
    {...props}
    minw={72}
    className={`FDBIllustration${
      props?.className ? ` ${props.className}` : ''
    }`}
  >
    <img
      src={hey_envelope}
      style={{ width: '100%' }}
      alt="Hey Envelope Illustration"
    />
  </Box>
);
export default HeyEnvelope;
